import { ButtonGroup, GameButton, HeaderSecondary, Spacer } from "@fedsim/components"
import { APP_VERSION } from '@fedsim/constants';

import useSaveGame from "hooks/useSaveGame"
import LoadSave from "components/load-save"
import TutorialAlert from "components/tutorial-alert";

import Size from './size';

import { Download } from "icons"
import { trackEv, Categories, Actions } from 'analytics'

export function Saves({
  size = "small",
  orientation = "horizontal",
  variant = "contained",
  color = "success",
  fullWidth = true,
}) {
  const { onDownload } = useSaveGame()
  const downloadHandler = () => {
    trackEv(Categories.Saves, Actions.Download)

    onDownload()
  }

  return (
    <>
      <TutorialAlert modelKey="alertSaveLoadOverview" withSpace />
      <ButtonGroup
        variant={variant}
        color={color}
        size={size}
        fullWidth={fullWidth}
        orientation={orientation}
        sx={{
          boxShadow: 0,
        }}
      >
        <GameButton onClick={downloadHandler} startIcon={<Download />}>Download Save</GameButton>
        <LoadSave />
      </ButtonGroup>
      <Spacer />
      <HeaderSecondary>version {APP_VERSION}</HeaderSecondary>
      <Spacer />
      <Size />
    </>
  )
}
export default Saves
